export const LanguageList = [
    {
        imageUrl: "/image/skills/javascript.png",
        altTag: "javascript image",
        title: "JavaScript"
    },
    {
        imageUrl: "/image/skills/html5.png",
        altTag: "HTML image",
        title: "HTML"
    },
    {
        imageUrl: "/image/skills/css3.png",
        altTag: "CSS image",
        title: "CSS"
    },
    {
        imageUrl: "/image/skills/ruby.png",
        altTag: "Ruby image",
        title: "Ruby"
    },
    {
        imageUrl: "/image/skills/sinatra.png",
        altTag: "Sinatra image",
        title: "Sinatra"
    },
    {
        imageUrl: "/image/skills/nodejs.png",
        altTag: "NodeJS image",
        title: "NodeJS"
    },
    {
        imageUrl: "/image/skills/puppeteer.png",
        altTag: "Puppeteer image",
        title: "Puppeteer"
    },
    {
        imageUrl: "/image/skills/expressjs.png",
        altTag: "Express image",
        title: "Express"
    },
    {
        imageUrl: "/image/skills/react.png",
        altTag: "React image",
        title: "React"
    },
    {
        imageUrl: "/image/skills/net.png",
        altTag: "DotNet image",
        title: ".Net"
    },
    {
        imageUrl: "/image/skills/csharp.png",
        altTag: "CSharp",
        title: "C#"
    },
    {
        imageUrl: "/image/skills/restful.png",
        altTag: "REST",
        title: "RESTful API"
    },
    {
        imageUrl: "/image/skills/storybook.png",
        altTag: "Storybook image",
        title: "Storybook"
    },
    {
        imageUrl: "/image/skills/liquid.png",
        altTag: "Liquid image",
        title: "Liquid"
    },
    {
        imageUrl: "/image/skills/vue.png",
        altTag: "Vue image",
        title: "Vue"
    },
    {
        imageUrl: "/image/skills/tailwind.png",
        altTag: "Tailwind image",
        title: "Tailwind"
    },
]